import { render, staticRenderFns } from "./blogAd.vue?vue&type=template&id=3386f966&scoped=true&lang=html&"
import script from "./blogAd.vue?vue&type=script&lang=js&"
export * from "./blogAd.vue?vue&type=script&lang=js&"
import style0 from "./blogAd.vue?vue&type=style&index=0&id=3386f966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386f966",
  null
  
)

export default component.exports